<div class="flex flex-row items-center" [class]="size">
  <div class="image-caption_image relative" *ngIf="img">
    <img
      hostPlaceholder
      src="/assets/status/placeholder.png"
      [delaySrc]="img"
      class="flex-shrink-0 w-20 h-14 rounded-[10px]"
    />
    <ng-content select=".image-caption_image_extra"></ng-content>
  </div>
  <ng-content select=".image-caption_image"></ng-content>
  <div *ngIf="caption" class="text-m">
    {{ caption }}
  </div>
  <ng-content select=".image-caption_caption"></ng-content>
</div>
